<div class="content-wrapped">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h3 class="fw-bold py-3 mb-4 text-primary">
            <mat-icon class="me-2 align-middle">edit</mat-icon>Configuración
            <div class="float-end">
                <button mat-flat-button color="primary" class="ms-4" *ngIf="hasPermissions('crear_pop_conf',null,true)" (click)="openAddEdit(false)"><mat-icon>add</mat-icon> Añadir nuevo</button>
            </div>
        </h3>

        <div style="padding-bottom: 25px;">
          <button mat-raised-button color="primary" class="same-height" [routerLink]="'/admin/projects/project/'+ mediaActual?.id_campana_proyecto+'/media/'+popActual?.id_proyecto_medio">
            <mat-icon>arrow_back</mat-icon><span class="nb-text">Atras</span>
          </button>
        </div>

      <div class="diagramacion-container">
        <div class="row">
          <div class="col-md-12">
              <div class="card mb-4">
                <h3 class="card-header">
                  <mat-icon>settings</mat-icon>Lista de Configuraciones
                </h3>
                      <div class="card-body">
                        <div class="overflow-auto w-200">
                          <mat-form-field>
                              <mat-label>
                                  <mat-icon>search</mat-icon> Buscar</mat-label>
                              <input matInput (keyup)="applyFilter($event,dataSource)" #input>
                          </mat-form-field>
                        </div>
                        <div class="table-container">
                          <table class="table table-hover" mat-table [dataSource]="dataSource" matSort>
                            <ng-container matColumnDef="id">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
                              <td mat-cell *matCellDef="let x"><small>{{ x.id }}</small></td>
                            </ng-container>
                            <ng-container matColumnDef="nombre">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                              <td mat-cell *matCellDef="let x"><strong>{{ x.nombre }}</strong></td>
                            </ng-container>
                            <ng-container matColumnDef="atributo">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header>Atributo</th>
                              <td mat-cell *matCellDef="let x">
                                <ul *ngFor="let s of x.reglas">
                                <li>
                                   <strong>Atributo:</strong> {{ s.nombre }}  
                                </li>
                                <li>
                                  <strong>Multiplicador:</strong> {{ s.multiplicador }} 
                                </li>
                              </ul>
                            </td>
                            </ng-container>
                            <ng-container matColumnDef="cantidad">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header>Cantidad</th>
                              <td mat-cell *matCellDef="let x"><small>{{x.cantidad || "Sin cantidad"}}</small></td>
                            </ng-container>
                            <ng-container matColumnDef="precio">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header>Precio</th>
                              <td mat-cell *matCellDef="let x"><small>{{ x.precio }}</small></td>
                            </ng-container>
                            <ng-container matColumnDef="creado">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header>Creado</th>
                              <td mat-cell *matCellDef="let x"><small>{{x.created_at  | date : "dd/MM/yyyy"}}</small></td>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header>Acciones</th>
                              <td mat-cell *matCellDef="let x">
                                <button mat-icon-button *ngIf="hasPermissions('edit_pop_conf',null,true)||hasPermissions('del_pop_conf',null,true)" (click)="$event.stopPropagation();" [matMenuTriggerFor]="menuCampana" matTooltip="Más acciones" [matTooltipPosition]="'above'" color="accent">
                                  <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menuCampana="matMenu">
                                    <button *ngIf="hasPermissions('edit_pop_conf',null,true)" (click)="openAddEdit(true, x)" mat-menu-item>
                                        <mat-icon>edit</mat-icon>
                                        <span>Editar</span>
                                    </button>
                                    <button *ngIf="hasPermissions('del_pop_conf',null,true)" (click)="deleteConfirm(x)" mat-menu-item>
                                        <mat-icon>delete</mat-icon>
                                        <span>Eliminar</span>
                                    </button>
                                </mat-menu>
                              </td>
                            </ng-container>
                              
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr (click)="openAddEdit(true, row)" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                            
                          </table>
                          <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
                        
                      </div>
                  </div>
              </div>
          </div>
        </div>
       <!-- <div class="row">
          <div *ngFor="let dia of elementosConfig" class="col-sm-6">
            <mat-card  class="card-configuration ">
              <mat-card-header>
                <mat-card-title><b>Nombre</b>: {{ dia.nombre }}</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <--<p *ngIf="mediaActual.formato != 2"><mat-slide-toggle [(ngModel)]="dia.isQuantity">Cantidad fija</mat-slide-toggle></p>  --           
                <div class="mb-4" *ngIf="mediaActual.formato != 2 && showFilters && !dia.isQuantity">
                  <h5 class="fw-bold text-primary">
                    <mat-icon class="me-2 align-middle">settings</mat-icon>Reglas de distribución
                  </h5>
                  <div *ngFor="let regla of dia.reglas; let i = index" class="mb-3">
                    <div class="row align-items-center"> 
                      <div class="col-md-3">
                        <mat-form-field appearance="outline" class="form-field">
                          <mat-label>Atributo</mat-label>
                          <mat-select [(ngModel)]="regla.id" name="atributo" (selectionChange)="setItemName($event.value, regla)">
                            <mat-option *ngFor="let atributo of atributosSucursales" [value]="atributo.id">{{ atributo.name }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div> 
                      
                      <div class="col-md-3 d-flex justify-content-center">
                        <span class="x-label">Multiplicado por:</span> 
                      </div>
                  
                      <div class="col-md-3">
                        <mat-form-field appearance="outline" class="form-field">
                          <mat-label>Valor</mat-label>
                          <input matInput name="multiplicador" [(ngModel)]="regla.multiplicador" placeholder="Ej: 10" />
                        </mat-form-field>
                      </div>
                  
                      <div class="col-md-2" style="margin-top: -20px;">
                        <button mat-icon-button color="warn" (click)="eliminarRegla(i,dia.reglas)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
      
                  <button *ngIf="dia.reglas?.length<1" mat-flat-button color="primary" (click)="agregarRegla(dia.reglas)">
                    <mat-icon>add</mat-icon> Añadir Regla
                  </button>
                </div>

                <div class="mb-4"  *ngIf="mediaActual.formato != 2 && showFilters && dia.isQuantity">
                  <h5 class="fw-bold text-primary">
                    <mat-icon class="me-2 align-middle">inventory</mat-icon>Definir Cantidad
                  </h5>
                  <div>
                  <div class="row align-items-center"> 
                      <div class="col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Cantidad</mat-label>
                          <input matInput type="number" min="1" [(ngModel)]="dia.cantidad" name="cantidad" step="-1">
                        </mat-form-field>
                    </div> 
                  </div>
                </div>
                </div>
                <div class="mb-4" *ngIf="showPrecio">
                  <h5 class="fw-bold text-primary">
                    <mat-icon class="me-2 align-middle">attach_money</mat-icon>Definir Precio
                  </h5>
                  <div>
                  <div class="row align-items-center"> 
                      <div class="col-md-6">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Precio</mat-label>
                          <input matInput type="number" min="1" [(ngModel)]="dia.precio" name="precio" step="-1">
                        </mat-form-field>
                    </div>
                  </div>
                </div>
                </div>


                <p *ngIf="dia.reglas?.length != 0">Inventario estimado: <span *ngIf="loadedInventorys"><b>{{findInventoryItem(dia.reglas[0].id)}}</b></span><span *ngIf="!loadedInventorys">Cargando...</span></p>

                <div class="button-group mt-4" *ngIf="dia.id != 0">
                  <button mat-raised-button color="primary" (click)="edit(dia)">Editar Configuración</button>
                </div>
                <div class="button-group mt-4" *ngIf="dia.id == 0">
                  <button mat-raised-button color="primary" (click)="save(dia)">Guardar Configuración</button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>-->
      
    </div>
  </div>